/**
 * The theme (see `helpers/theme.ts`) for function components: they re-render when it changes, also when another tab
 * changes it. `<html>` follows it by itself, a component only needs it to show which theme is on.
 */
import {useSyncExternalStore} from 'react';

import type {Theme} from '../helpers/session';
import {getTheme, subscribe} from '../helpers/session';

/** The theme the terminal shows: `'light'` or `'dark'`. */
export const useTheme = (): Theme => useSyncExternalStore(subscribe, getTheme);
